// Start acm-quiz.js
(function() {
  /**
   * acm quiz
   *
   * @description The Wine Quiz component.
   * @param {Object} options The options hash
   */
  const acm_quiz = function(questions) {
    let currentQuestion = 0;
    let score = [];
    let selectedAnswersData = [];
    const totalQuestions =questions.length;

    const container = document.querySelector('.quiz-container');
    const questionEl = document.querySelector('.question');
    const option1 = document.querySelector('.option1');
    const option2 = document.querySelector('.option2');
    const option3 = document.querySelector('.option3');
    const option4 = document.querySelector('.option4');
    const nextButton = document.querySelector('.next-quiz');
    const previousButton = document.querySelector('.previous');
    const restartButton = document.querySelector('.restart');
    const leadForm = document.querySelector('.quiz-lead-form');
    const result = document.querySelector('.result');
    const summaryTop = document.querySelector('.summary-top');
    const summaryBottom = document.querySelector('.summary-bottom');
    const slideshowColumn = document.querySelector('.quiz-slideshow-column');
    // var initCalled = false;

    //Function to generate question
  function generateQuestions (index) {
    //Select each question by passing it a particular index
    const question = questions[index];
    const option1Total = questions[index].answer1Total;
    const option2Total = questions[index].answer2Total;
    const option3Total = questions[index].answer3Total;
    const option4Total = questions[index].answer4Total;
    //Populate html elements
    questionEl.innerHTML = `${index + 1}. ${question.question}`
    option1.setAttribute('data-total', `${option1Total}`);
    option2.setAttribute('data-total', `${option2Total}`);
    option3.setAttribute('data-total', `${option3Total}`);
    option4.setAttribute('data-total', `${option4Total}`);
    option1.innerHTML = `${question.answer1}`
    option2.innerHTML = `${question.answer2}`
    option3.innerHTML = `${question.answer3}`
    option4.innerHTML = `${question.answer4}`

    //If quiz is on the first question
    if(currentQuestion == 0) {
      previousButton.style.display = 'none';
    } else {
      previousButton.style.display = 'initial';
    }
  }

  function loadNextQuestion () {
    const selectedOption = document.querySelector('input[type="radio"]:checked');
    //Check if there is a radio input checked
    if(!selectedOption) {
        alert('Please select your answer!');
        return;
    }
    //Get value of selected radio
    const answerScore = Number(selectedOption.nextElementSibling.getAttribute('data-total'));

    ////Add the answer score to the score array
    score.push(answerScore);

    selectedAnswersData.push()


    const totalScore = score.reduce((total, currentNum) => total + currentNum);

    //Finally we incement the current question number ( to be used as the index for each array)
    currentQuestion++;

        //once finished clear checked
        selectedOption.checked = false;
    //If quiz is on the final question
    if(currentQuestion == totalQuestions - 1) {
        nextButton.textContent = 'Finish';
    }
    //If the quiz is finished then we hide the questions container and show the results
    if(currentQuestion == totalQuestions && totalScore < 22) {
        container.style.display = 'none';
  			slideshowColumn.style.display = 'none';
  			leadForm.style.display = 'block';
        summaryTop.innerHTML =
         `
          <div class="result-img" style="background-image: url(/wp-content/uploads/2021/12/chardonnay-600px.jpg)"></div>
         `;
        summaryBottom.innerHTML =
         `
    			<div>
            <p class="final-score">You are:</p>
            <h3>Chardonnay!</h3>
            <p>Refined and Classy - Always a welcome addition to any party but stand out on your own if the mood strikes you.</p>
            <div class="results-buttons" results-buttons>
              <a href="/wine/1000-stories-chardonnay-2020/" class="button">Shop</a>
              <button class="restart button">Restart Quiz</button>
      			</div>
    			</div>
         `;
        return;
    } else if (currentQuestion == totalQuestions && totalScore >= 22 && totalScore < 27) {
        container.style.display = 'none';
  			slideshowColumn.style.display = 'none';
  			leadForm.style.display = 'block';
        summaryTop.innerHTML =
         `
          <div class="result-img" style="background-image: url(/wp-content/uploads/2021/12/gold-rush-red-600px.jpg)"></div>
         `;
        summaryBottom.innerHTML =
         `<div>
            <p class="final-score">You are:</p>
            <h3>Gold Rush Red!</h3>
      			<p>Fun and Casual - You’re ready for any kind of hoedown and fit right in wherever you find yourself.</p>
      			<div class="results-buttons" results-buttons>
        			<a href="/wine/gold-rush-red-blend-2018/" class="button">Shop</a>
        			<button class="restart button">Restart Quiz</button>
      			</div>
    			</div>
         `;
        return;
    } else if (currentQuestion == totalQuestions && totalScore >= 27 && totalScore < 30) {
        container.style.display = 'none';
  			slideshowColumn.style.display = 'none';
  			leadForm.style.display = 'block';
        summaryTop.innerHTML =
         `
         <div class="result-img" style="background-image: url(/wp-content/uploads/2021/12/prospectors-proof-600px.jpg)"></div>
         `;
        summaryBottom.innerHTML =
         `
         <div>
          <p class="final-score">You are:</p>
      			<h3>Prospector's Proof Cabernet!</h3>
      			<p>A Wild Card and Always On - You’re the life of the party with plenty of stories to keep everyone in stitches.</p>
      			<div class="results-buttons" results-buttons>
        			<a href="/wine/prospectors-proof-2017-1-5l-handle/" class="button">Shop</a>
        			<button class="restart button">Restart Quiz</button>
      			</div>
    			</div>
         `;
        return;
    } else if (currentQuestion == totalQuestions && totalScore >= 30) {
        container.style.display = 'none';
  			slideshowColumn.style.display = 'none';
  			leadForm.style.display = 'block';
        summaryTop.innerHTML =
         `
          <div class="result-img" style="background-image: url(/wp-content/uploads/2021/12/zinfandel-600px.jpg)"></div>
         `;
        summaryBottom.innerHTML =
         `
    			<div>
          <p class="final-score">You are:</p>
      			<h3>Zinfandel!</h3>
      			<p>Classic and Quintessential - Viewed as an original in everything you do. Revered but not feared because you still know how to have a good time.</p>
      			<div class="results-buttons" results-buttons>
        			<a href="/wine/2020-zinfandel-batch-83/" class="button">Shop</a>
        			<button class="restart button">Restart Quiz</button>
      			</div>
    			</div>
         `;
        return;
    }
    generateQuestions(currentQuestion);
  }

  //Function to load previous question
  function loadPreviousQuestion() {
    //Decrement quentions index
    currentQuestion--;
    //remove last array value;
    score.pop();
    //Generate the question
    generateQuestions(currentQuestion);
  }

  //Fuction to reset and restart the quiz;
  function restartQuiz(e) {
    if(e.target.matches('button')) {
    //reset array index and score
    currentQuestion = 0;
    score = [];
    //Reload quiz to the start
    location.reload();
    }

  }

  generateQuestions(currentQuestion);
  nextButton.addEventListener('click', loadNextQuestion);
  previousButton.addEventListener('click',loadPreviousQuestion);
  result.addEventListener('click',restartQuiz);

  //Quiz Slideshow
  var slides = document.querySelectorAll('#quizSlides .quiz-slide');
  var currentSlide = 0;
  var slideInterval = setInterval(nextSlide,2000);

  function nextSlide(){
  	slides[currentSlide].className = 'quiz-slide';
  	currentSlide = (currentSlide+1)%slides.length;
  	slides[currentSlide].className = 'quiz-slide showing';
  }


    /**
     * init
     *
     * @description Initializes the component by removing the no-js class from
     *   the component, and attaching event listeners to each of the nav items.
     *   Returns nothing.
     */


    /**
     * Returns init
     */
    // return {
    //   init: init
    //   // goToTab: goToTab
    // };
  };

  /**
   * Attach to global namespace
   */
  window.acm_quiz = acm_quiz;
})();
// End acm-quiz.js
